/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SlackDirectoryConnection,
  SlackDirectoryConnection$inboundSchema,
} from "./slackdirectoryconnection.js";

export type ListResponseBody = {
  /**
   * Whether the deployment can start Slack OAuth.
   */
  authorizationConfigured: boolean;
  /**
   * Workspace connections in creation order.
   */
  connections: Array<SlackDirectoryConnection>;
};

/** @internal */
export const ListResponseBody$inboundSchema: z.ZodMiniType<
  ListResponseBody,
  unknown
> = z.pipe(
  z.object({
    authorization_configured: z.boolean(),
    connections: z.array(SlackDirectoryConnection$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "authorization_configured": "authorizationConfigured",
    });
  }),
);

export function listResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<ListResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListResponseBody' from JSON`,
  );
}
